import React from 'react';
import './LeaveBalance.css';

export const LeaveBalance = ({ balance }) => {
  const percentage = balance.maxDays > 0 ? (balance.usedDays / balance.maxDays) * 100 : 0;
  const remaining = balance.remainingDays;

  const getColorClass = () => {
    const percentageRemaining = 100 - percentage;
    if (percentageRemaining > 50) return 'color-green';
    if (percentageRemaining > 25) return 'color-amber';
    return 'color-red';
  };

  return (
    <div className={`leave-balance-card ${getColorClass()}`}>
      <div className="balance-header">
        <h3 className="balance-type">{balance.leaveTypeName}</h3>
      </div>

      <div className="balance-progress">
        <div className="progress-bar-container">
          <div className="progress-bar-background">
            <div
              className="progress-bar-fill"
              style={{ width: `${percentage}%` }}
            ></div>
          </div>
        </div>
        <div className="progress-labels">
          <span className="used">Used: {balance.usedDays.toFixed(1)}</span>
          <span className="remaining">Remaining: {remaining.toFixed(1)}</span>
        </div>
      </div>

      <div className="balance-stats">
        <div className="stat-item">
          <span className="stat-label">Total</span>
          <span className="stat-value">{balance.maxDays.toFixed(1)}</span>
        </div>
        <div className="stat-divider"></div>
        <div className="stat-item">
          <span className="stat-label">Used</span>
          <span className="stat-value">{balance.usedDays.toFixed(1)}</span>
        </div>
        <div className="stat-divider"></div>
        <div className="stat-item">
          <span className="stat-label">Available</span>
          <span className="stat-value highlight">{remaining.toFixed(1)}</span>
        </div>
      </div>
    </div>
  );
};

export default LeaveBalance;
